import './style.scss';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import {
  createControlSocialActivityGroup,
  createSchoolGroup,
  getBeneficiariesBySchool,
  getList,
  getNeighborhoods
} from '../../../API/apiService';
import ArrowTriggerIcon from '../../../assets/icons/arrowTrigger.svg';
import DefaultGroupIcon from '../../../assets/icons/defaultGroupIcon.svg';
import EditIcon from '../../../assets/icons/edit.svg';
import HatSchoolBlue from '../../../assets/icons/hatSchoolBlue.svg';
import UsersIcon from '../../../assets/icons/userss.svg';
import DownloadBeneficiaries from '../../downloadBeneficiaries';
import ModalContainer from '../../modalContainer';
import CustomFilterSelect from '../../../shared/customFilterSelect';

function formatCreationDate(rawDate) {
  if (!rawDate) return '-';

  const date = new Date(rawDate);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('es-CO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}

function MenuItem({
  uid,
  school,
  onEditSocialization,
  onGroupCreated,
  isMediatorCop = false,
  isSocialControlMediator = false,
  municipalities = [],
  visibilityAction = 'hide',
  onToggleVisibility
}) {
  const [expanded, setExpanded] = useState(false);
  const [rendered, setRendered] = useState(false);
  const [openAddGroupModal, setOpenAddGroupModal] = useState(false);
  const [groupType, setGroupType] = useState('');
  const [selectedMunicipality, setSelectedMunicipality] = useState('');
  const [selectedNeighborhood, setSelectedNeighborhood] = useState('');
  const [groupPlace, setGroupPlace] = useState('');
  const [groupAddress, setGroupAddress] = useState('');
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [loadingNeighborhoods, setLoadingNeighborhoods] = useState(false);
  const [creatingGroup, setCreatingGroup] = useState(false);
  const [advisorBeneficiaries, setAdvisorBeneficiaries] = useState([]);
  const [advisorGenders, setAdvisorGenders] = useState([]);
  const [loadingAdvisorBeneficiaries, setLoadingAdvisorBeneficiaries] = useState(false);
  const schoolGroups = Array.isArray(school?.groups) ? school.groups : [];
  const activeAdvisorBeneficiaries = Array.isArray(advisorBeneficiaries)
    ? advisorBeneficiaries.filter(beneficiary => beneficiary?.active !== false)
    : [];
  const schoolName = school?.name ?? school?.address ?? school?.code ?? '-';
  const createdAtValue = formatCreationDate(school?.createdAt ?? school?.created_at);
  const firstFieldLabel = isMediatorCop ? 'Fecha de creacion' : 'Comuna';
  const firstFieldValue = isMediatorCop
    ? createdAtValue
    : school?.municipality?.name || '-';
  const nameFieldLabel = isMediatorCop
    ? 'Nombre de la Asesoria'
    : 'Nombre de la Entidad Aliada';
  const codeFieldLabel = isMediatorCop
    ? 'Codigo de Asesoria'
    : 'Codigo de Proceso Formativo';
  const emptyGroupsLabel = isMediatorCop
    ? 'Aun no hay grupos en esta Asesoria'
    : isSocialControlMediator
      ? 'Aún no hay grupos en esta actividad'
      : 'Aun no hay grupos en este Proceso Formativo';
  const isShowingHiddenItem = visibilityAction === 'show';
  const safeAdvisorCode = String(school?.code || `asesoria_${school?.id || ''}`)
    .replace(/[^a-zA-Z0-9_-]+/g, '_');
  const advisorBeneficiariesFileName = `beneficiarios_${safeAdvisorCode}.xlsx`;

  useEffect(() => {
    const checkbox = document.getElementById(`s${school.id}`);
    const root = document.querySelector(':root');

    root.style.setProperty(
      '--expanded-item-height',
      schoolGroups.length > 2 ? '23.5rem' : '19.25rem'
    );

    if (uid === 0 && !expanded && !rendered && checkbox) {
      checkbox.checked = true;
      setRendered(true);
      setExpanded(true);
    }
  }, [uid, school?.id, schoolGroups.length, expanded, rendered]);

  useEffect(() => {
    let isMounted = true;

    async function loadAdvisorDownloadData() {
      if (!isMediatorCop || !school?.id) return;

      setLoadingAdvisorBeneficiaries(true);
      const [beneficiariesList, gendersList] = await Promise.all([
        getBeneficiariesBySchool(school.id),
        getList('gender')
      ]);

      if (!isMounted) return;

      setAdvisorBeneficiaries(Array.isArray(beneficiariesList) ? beneficiariesList : []);
      setAdvisorGenders(Array.isArray(gendersList) ? gendersList : []);
      setLoadingAdvisorBeneficiaries(false);
    }

    loadAdvisorDownloadData();

    return () => {
      isMounted = false;
    };
  }, [isMediatorCop, school?.id]);

  function closeAddGroupModal(force = false) {
    if (creatingGroup && !force) return;
    setOpenAddGroupModal(false);
    setGroupType('');
    setSelectedMunicipality('');
    setSelectedNeighborhood('');
    setGroupPlace('');
    setGroupAddress('');
    setNeighborhoods([]);
  }

  async function selectMunicipality(_selectName, municipalityId) {
    const parsedMunicipalityId = Number(municipalityId);
    const validMunicipalityId =
      Number.isInteger(parsedMunicipalityId) && parsedMunicipalityId > 0
        ? parsedMunicipalityId
        : '';

    setSelectedMunicipality(validMunicipalityId);
    setSelectedNeighborhood('');
    setNeighborhoods([]);

    if (!validMunicipalityId) return;

    setLoadingNeighborhoods(true);
    const response = await getNeighborhoods(validMunicipalityId);
    setNeighborhoods(Array.isArray(response) ? response : []);
    setLoadingNeighborhoods(false);
  }

  function selectNeighborhood(_selectName, neighborhoodId) {
    const parsedNeighborhoodId = Number(neighborhoodId);
    setSelectedNeighborhood(
      Number.isInteger(parsedNeighborhoodId) && parsedNeighborhoodId > 0
        ? parsedNeighborhoodId
        : ''
    );
  }

  async function handleCreateGroup() {
    if (isSocialControlMediator) {
      if (!groupPlace.trim()) {
        toast('Ingresa el Lugar', { type: 'warning' });
        return;
      }

      if (!groupAddress.trim()) {
        toast('Ingresa la Dirección', { type: 'warning' });
        return;
      }

      if (!selectedMunicipality || !selectedNeighborhood) {
        toast('Selecciona la Comuna y el Barrio', { type: 'warning' });
        return;
      }

      if (!school?.id) return;

      setCreatingGroup(true);
      const response = await createControlSocialActivityGroup(
        Number(school.id),
        {
          municipalityId: Number(selectedMunicipality),
          neighborhoodId: Number(selectedNeighborhood),
          place: groupPlace.trim(),
          address: groupAddress.trim()
        }
      );
      setCreatingGroup(false);

      if (response?.success) {
        toast('Grupo creado exitosamente', { type: 'success' });
        closeAddGroupModal(true);
        await onGroupCreated?.();
        return;
      }

      const errorMessages = {
        ACTIVITY_NOT_FOUND: 'La actividad no existe o no pertenece al mediador',
        TERRITORY_INVALID: 'El Barrio no pertenece a la Comuna seleccionada',
        PLACE_REQUIRED: 'Ingresa un Lugar valido',
        ADDRESS_REQUIRED: 'Ingresa una Dirección válida',
        ACTIVITY_GROUP_SAVE_FAILED: 'No fue posible guardar el grupo'
      };
      toast(errorMessages[response?.code] || 'Error creando grupo', {
        type: 'error'
      });
      return;
    }

    if (!groupType) {
      toast('Selecciona un tipo de grupo', { type: 'warning' });
      return;
    }

    if (!school?.id) return;

    setCreatingGroup(true);
    const response = await createSchoolGroup({
      schoolId: Number(school.id),
      groupType
    });
    setCreatingGroup(false);

    if (response?.success) {
      toast('Grupo creado exitosamente', { type: 'success' });
      closeAddGroupModal(true);
      await onGroupCreated?.();
      return;
    }

    toast('Error creando grupo', { type: 'error' });
  }

  return (
    <>
      {openAddGroupModal && (
        <ModalContainer>
          <section className='school-group-modal'>
            <h3 className='school-group-modal__title'>Agregar grupo</h3>
            {isSocialControlMediator ? (
              <div className='school-group-modal__territory'>
                <div className='school-group-modal__field'>
                  <label
                    className='school-group-modal__label'
                    htmlFor={`activity-place-${school.id}`}
                  >
                    Lugar
                  </label>
                  <input
                    id={`activity-place-${school.id}`}
                    className='school-group-modal__input'
                    type='text'
                    value={groupPlace}
                    maxLength={255}
                    onChange={(event) => setGroupPlace(event.target.value)}
                    disabled={creatingGroup}
                    placeholder='Lugar'
                  />
                </div>
                <div className='school-group-modal__field'>
                  <label
                    className='school-group-modal__label'
                    htmlFor={`activity-address-${school.id}`}
                  >
                    Dirección
                  </label>
                  <input
                    id={`activity-address-${school.id}`}
                    className='school-group-modal__input'
                    type='text'
                    value={groupAddress}
                    maxLength={255}
                    onChange={(event) => setGroupAddress(event.target.value)}
                    disabled={creatingGroup}
                    placeholder='Dirección'
                  />
                </div>
                <CustomFilterSelect
                  key={`activity-municipality-${school.id}-${selectedMunicipality || 'none'}`}
                  placeholder='Comuna'
                  optionsList={municipalities}
                  addInfo={selectMunicipality}
                  valueEdit={
                    municipalities.find(
                      municipality =>
                        Number(municipality?.id) ===
                        Number(selectedMunicipality)
                    )?.name || ''
                  }
                />
                <CustomFilterSelect
                  key={`activity-neighborhood-${school.id}-${selectedMunicipality || 'none'}-${selectedNeighborhood || 'none'}`}
                  placeholder={
                    loadingNeighborhoods ? 'Cargando barrios...' : 'Barrio'
                  }
                  optionsList={neighborhoods}
                  addInfo={selectNeighborhood}
                  searchable={true}
                  searchPlaceholder='Escribe para buscar barrio'
                  disabled={!selectedMunicipality || loadingNeighborhoods}
                  valueEdit={
                    neighborhoods.find(
                      neighborhood =>
                        Number(neighborhood?.id) ===
                        Number(selectedNeighborhood)
                    )?.name || ''
                  }
                />
              </div>
            ) : (
              <>
                <label
                  className='school-group-modal__label'
                  htmlFor={`group-type-${school.id}`}
                >
                  Tipo de grupo
                </label>
                <select
                  id={`group-type-${school.id}`}
                  className='school-group-modal__select'
                  value={groupType}
                  onChange={(event) => setGroupType(event.target.value)}
                  disabled={creatingGroup}
                >
                  <option value=''>Selecciona una opcion</option>
                  <option value='DOCENTES'>Docentes</option>
                  <option value='ESTUDIANTES'>Estudiantes</option>
                  <option value='COMUNIDAD'>Comunidad</option>
                </select>
              </>
            )}
            <div className='school-group-modal__actions'>
              <button
                type='button'
                className='blue-site-button'
                onClick={handleCreateGroup}
                disabled={creatingGroup}
              >
                {creatingGroup ? 'CREANDO...' : 'CREAR'}
              </button>
              <button
                type='button'
                className='button-white-border-blue'
                onClick={closeAddGroupModal}
                disabled={creatingGroup}
              >
                CANCELAR
              </button>
            </div>
          </section>
        </ModalContainer>
      )}

      <input
        type='radio'
        id={'s' + school.id}
        name='schoolRadio'
        checked={expanded}
        onChange={({ target }) => setExpanded(target.checked)}
      />
      <div className='school'>
        <label htmlFor={'s' + school.id.toString()} className='school__expand expand'>
          <img
            src={ArrowTriggerIcon}
            className='expand__icon expand__icon--img'
            alt=''
            aria-hidden='true'
          />
        </label>

        <div className='school__info info'>
          {isSocialControlMediator ? (
            <>
              <div className='info__field field'>
                <div className='field__icon icon'>
                  <span
                    className='material-symbols-rounded icon__img'
                    aria-hidden='true'
                  >
                    event_available
                  </span>
                </div>
                <span className='field__title'>Nombre de la actividad</span>
                <span className='field__value'>{schoolName}</span>
              </div>

              <div className='info__field field'>
                <div className='field__icon icon'>
                  <span
                    className='material-symbols-rounded icon__img'
                    aria-hidden='true'
                  >
                    account_tree
                  </span>
                </div>
                <span className='field__title'>Línea</span>
                <span className='field__value'>{school?.line || '-'}</span>
              </div>
            </>
          ) : (
            <>
              <div className='info__field field'>
                <div className='field__icon icon'>
                  <img
                    src={HatSchoolBlue}
                    className='icon__img icon__img--svg'
                    alt=''
                    aria-hidden='true'
                  />
                </div>
                <span className='field__title'>{firstFieldLabel}</span>
                <span className='field__value'>{firstFieldValue}</span>
              </div>

              <div className='info__field field'>
                <div className='field__icon icon'>
                  <img
                    src={HatSchoolBlue}
                    className='icon__img icon__img--svg'
                    alt=''
                    aria-hidden='true'
                  />
                </div>
                <span className='field__title'>{nameFieldLabel}</span>
                <span className='field__value'>{schoolName}</span>
              </div>
            </>
          )}

          {isMediatorCop && (
            <div className='info__field field'>
              <div className='field__icon icon'>
                <img
                  src={HatSchoolBlue}
                  className='icon__img icon__img--svg'
                  alt=''
                  aria-hidden='true'
                />
              </div>
              <span className='field__title'>Dependencia</span>
              <span className='field__value'>{school?.organization || '-'}</span>
            </div>
          )}

          {!isSocialControlMediator && (
            <div className='info__field field'>
              <div className='field__icon icon'>
                <span
                  className='material-symbols-rounded icon__img icon__img--clip'
                  aria-hidden='true'
                >
                  attach_file
                </span>
              </div>
              <span className='field__title'>{codeFieldLabel}</span>
              <span className='field__value'>{school?.code || '-'}</span>
            </div>
          )}
        </div>

        <div className='school__actions'>
          {typeof onToggleVisibility === 'function' && (
            <button
              type='button'
              className={`school-actions-btn school-actions-btn--visibility${
                isShowingHiddenItem ? ' school-actions-btn--visibility-show' : ''
              }`}
              onClick={() => onToggleVisibility(school)}
              title={isShowingHiddenItem ? 'Volver a mostrar' : 'Ocultar'}
              aria-label={isShowingHiddenItem ? 'Volver a mostrar' : 'Ocultar'}
            >
              <span
                className='material-symbols-rounded school-actions-btn__icon'
                aria-hidden='true'
              >
                {isShowingHiddenItem ? 'visibility' : 'visibility_off'}
              </span>
              <span>{isShowingHiddenItem ? 'Mostrar' : 'Ocultar'}</span>
            </button>
          )}

          {isMediatorCop ? (
            <div className='school__cop-actions school-cop-actions'>
              <DownloadBeneficiaries
                beneficiaries={activeAdvisorBeneficiaries}
                genders={advisorGenders}
                buttonText={
                  loadingAdvisorBeneficiaries
                    ? 'Cargando beneficiarios...'
                    : 'Descargar Beneficiarios'
                }
                buttonIcon='download'
                iconClassName='school-actions-btn__icon'
                buttonClassName='school-actions-btn school-actions-btn--download-beneficiaries school-cop-actions__btn'
                containerClassName='school-cop-actions__download'
                fileName={advisorBeneficiariesFileName}
                characterizationMode='cop'
                disabled={
                  loadingAdvisorBeneficiaries ||
                  activeAdvisorBeneficiaries.length === 0
                }
                schoolNameColumnLabel='NOMBRE ASESORIA'
                processColumnLabel='ASESORIA'
                includeGroupColumns={false}
                processMunicipalityColumnLabel='COMUNA ASESORIA'
              />

              <Link
                to={`/escuelas/asesoria/${school?.id}`}
                state={{ school, backTo: '/escuelas' }}
                className='school-actions-btn school-actions-btn--evidences school-cop-actions__btn'
              >
                <span
                  className='material-symbols-rounded school-actions-btn__icon'
                  aria-hidden='true'
                >
                  folder_open
                </span>
                <span>Evidencias</span>
              </Link>
            </div>
          ) : isSocialControlMediator ? (
            <button
              type='button'
              className='school-actions-btn school-actions-btn--add-group'
              onClick={() => setOpenAddGroupModal(true)}
            >
              <span
                className='material-symbols-rounded school-actions-btn__icon'
                aria-hidden='true'
              >
                add
              </span>
              <span>Agregar grupo</span>
            </button>
          ) : (
            <>
              <button
                type='button'
                className='school-actions-btn school-actions-btn--socialization'
                onClick={() => onEditSocialization?.(school, 'socializacion', 1)}
              >
                <img
                  src={EditIcon}
                  className='school-actions-btn__icon school-actions-btn__icon--img'
                  alt=''
                  aria-hidden='true'
                />
                <span>Socialización 1</span>
              </button>

              <button
                type='button'
                className='school-actions-btn school-actions-btn--socialization'
                onClick={() => onEditSocialization?.(school, 'socializacion', 2)}
              >
                <img
                  src={EditIcon}
                  className='school-actions-btn__icon school-actions-btn__icon--img'
                  alt=''
                  aria-hidden='true'
                />
                <span>Socialización 2</span>
              </button>

              <button
                type='button'
                className='school-actions-btn school-actions-btn--add-group'
                onClick={() => setOpenAddGroupModal(true)}
              >
                <span
                  className='material-symbols-rounded school-actions-btn__icon'
                  aria-hidden='true'
                >
                  add
                </span>
                <span>Agregar grupo</span>
              </button>
            </>
          )}
        </div>

        {!isMediatorCop && (
          <div className='school__groups groups'>
            <div className='groups__field field'>
              <div className='field__icon icon'>
                <img
                  src={UsersIcon}
                  className='icon__img icon__img--svg'
                  alt=''
                  aria-hidden='true'
                />
              </div>
              <span className='field__title'>Grupos</span>
            </div>
            <div className='groups__content wrapper'>
              {schoolGroups.length > 0 &&
                schoolGroups.map((group) =>
                  isSocialControlMediator ? (
                    <Link
                      to={`/escuelas/grupo?activityId=${school.id}&activityGroupId=${group.id}`}
                      state={{
                        controlSocialContext: true,
                        activity: school,
                        activityGroup: group,
                        backTo: '/escuelas'
                      }}
                      key={group.id}
                      className='wrapper__item item item--activity-group'
                    >
                      <img
                        className='item__icon'
                        src={DefaultGroupIcon}
                        alt=''
                        aria-hidden='true'
                      />
                      <span className='item__name'>{group.code}</span>
                      <span className='item__territory'>
                        {group.comuna} · {group.barrio}
                      </span>
                      <span
                        className='material-symbols-rounded item__go'
                        aria-hidden='true'
                      >
                        arrow_forward_ios
                      </span>
                    </Link>
                  ) : (
                    <Link
                      to='/escuelas/grupo'
                      state={{ school, group, backTo: '/escuelas' }}
                      key={group.id}
                      className='wrapper__item item'
                    >
                      <img
                        className='item__icon'
                        src={DefaultGroupIcon}
                        alt='Group_Icon'
                      />
                      <span className='item__name'>{group.code}</span>
                      <span
                        className='material-symbols-rounded item__go'
                        aria-hidden='true'
                      >
                        arrow_forward_ios
                      </span>
                    </Link>
                  )
                )}
              {schoolGroups.length === 0 && (
                <p className='groups__empty'>{emptyGroupsLabel}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default MenuItem;
